<template>
  <div class="a-container">
    <header class="restaurants__gallery-wrap a-container__offset">
      <HUIGallery
        :always-fade="true"
        @change="handleGalleryChange"
        v-if="gallery && entered"
        :images="galleryImages"
        class="restaurants__gallery"
      ></HUIGallery>
      <transition name="t-fade">
        <div class="a-rich-text restaurants__intro" v-if="restaurant && galleryActiveIndex === 0">
          <h1 class="a-page-title">Halifax {{ restaurant.name }}</h1>
          <a target="blank" :href="googleMapsLink">
            {{ restaurant.address }} {{ restaurant.street_number }}
            <br />
            {{ restaurant.zip_code }} {{ restaurant.city }}
          </a>
        </div>
      </transition>
    </header>
    <TableCTA class="restaurants__content-module"></TableCTA>
    <template v-if="entered && relevantContent">
      <template v-for="(contentModule, index) in relevantContent">
        <!-- <div
          :key="'content-module-' + index + contentModule.type"
          v-if="contentModule.type === 'restaurant-map'"
          class="restaurants__content-module"
        >
          <a :href="contentModule.link" target="_blank">
            Google maps
          </a>
        </div>-->
        <div
          v-if="contentModule.type === 'restaurant-info'"
          :key="'content-module-' + index + contentModule.type"
          class="a-rich-text restaurants__content-module"
        >
          <div class="restaurants__content-module a-rich-text">
            <div class="a-rich-text" v-html="contentModule.text"></div>
            <div class="a-button-group a-button-group--stacked">
              <RouterButton
                theme="blue"
                v-if="restaurant.has_table_booking"
                :to="{ name: routes.BOOKING, query: { restaurant: $route.params.restaurantSlug }} "
              >Book bord</RouterButton>
              <RouterButton theme="green" :to="routes.TAKEAWAY">Bestil takeaway</RouterButton>
              <a :href="'tel://+45' + restaurant.phone" class="hui-button hui-button--default">
                <img
                  width="24"
                  height="24"
                  alt="Telefon"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAC9ElEQVR4Ac2YA6wlSxCGn23btm3btu33grfeYG0zWDNeRmtEa+Nouo7PTNWZrjVOhde3e5I7vUn+YPi1/sJRL/71WiOtX7/+hBAzr2qE7pqgVxjAS3LdpZq8qAneY4L5jKrACEUmNZvRe+SIAc3n15/GqGbuqmYPNRQT7GOEz5yDZrOrT9WoFtaFaxrWe9gpKBMMagmyDuy6RCJxkhPQ0Ff3MMF+E1BRiN5XTkA1qfEmgHVmdc20adOOjRW0UtlxppxuAbCDVY/HClr1vWdtIUWaVN9YQTWqP6OAMsHKWEGZYHBE0N1cgSvjBB0bBVQUVjJ3xrf0pPpEgkTv63iXHuFLyyU/yAifx+6jRHCzjdlzoD51FkI1whKDmeQQvW+cJiWa4GcD0PnO07wgSJ0teWcroHl5znmaJ5l8q7OK8I9zUN9PXi37sBXQIhGc7zrDN4pSmmCic1BdSl/KBGQA+4vz4k6j6mrgAHuqfuYpp6DF4qbTmWBrq7CoCtVy6lan5XI18J4zDKeJmmVd4wxUxKiGG8Ju8f3EVc5ApdKU2sh0ZongFpsfB0H6OiaYp1F1QfRujAwqqlbStzNBaASLqmDaTeGKuoIJttUZ6F5NMFUHcH8kUJEm9ZakdoYzGzLCF01+q25gQdjUgvVNCn3vbmtQkfimVc6KMFqq28bLnbqGCbYbDHg/oxoa5hMXWYGKmKC9DawAceB9tHXr1hPlfamvxPYsv5HXgferDNrq5DHCfxGKwG3iIHX3pP03VDtrm5Dcte6ejUNSVUTyNGnyMkEuFkiCiuxtW8i6B+NaTbCsrUE1wWSbw9RsC10j9DQvDu0lyY8BqJnEqKUJ3AazOcHAnuwlTQkDnzTdmzur2e0XGILaSyl1ig7U73XzhCiWRqRuso5MUdS5c+djQoSXGdUMJkCL5Z5Ydyajg0ZQWEheLFFKOttMsLamfE0skoKR5RrCSI2Zh6yTEnOZO4QcupDUdxqhOyOMqmm0lOm1a9+31hk8DGXl7hM/50WAAAAAAElFTkSuQmCC"
                />
                <span>{{ spaceEverySecondCharacter(restaurant.phone) }}</span>
              </a>
            </div>
          </div>
          <fieldset
            class="restaurants__content-module restaurants__opening-hours a-bordered-fieldset"
          >
            <legend class="a-bordered-fieldset__legend">Åbningstider</legend>
            <dl>
              <template v-for="(obj, index) in restaurant.opening_hours">
                <dt
                  :key="'opening-hour-dt-' + index"
                  :style="'font-weight: ' + (todayIndex === obj.index ? '700' : 'inherit')"
                >{{ obj.name }}</dt>
                <dd
                  :key="'opening-hour-dd-' + index"
                  :style="'font-weight: ' + (todayIndex === obj.index ? '700' : 'inherit')"
                  v-if="!obj.is_closed"
                >{{ obj.opening_time }} &ndash; {{ obj.closing_time }}</dd>
                <dd :key="'opening-hour-dd-' + index" v-else>Lukket</dd>
              </template>
            </dl>
          </fieldset>
        </div>
        <div
          :key="'content-module-' + index + contentModule.type"
          v-else-if="contentModule.type === 'text'"
          class="restaurants__content-module a-rich-text"
        >
          <h2 v-if="contentModule.headline">{{ contentModule.headline }}</h2>
          <div class="a-rich-text" v-if="contentModule.content" v-html="contentModule.content"></div>
        </div>
        <hr
          :key="'content-module-' + index + contentModule.type"
          v-else-if="contentModule.type === 'divider'"
          class="restaurants__content-module"
        />
      </template>
    </template>
    <HUILoadingView v-else class="restaurants__content-module" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { HUISlider, HUILoadingView, HUIGallery } from '@/halifax-ui'
import PageVC from '@/containers/PageVC'
import RouterButton from '@/containers/RouterButton'
import TableCTA from '@/containers/TableCTA'
import routes from '@/router/routes'

export default {
  components: {
    PageVC,
    HUISlider,
    HUILoadingView,
    HUIGallery,
    RouterButton,
    TableCTA
  },
  data() {
    return {
      routes,
      galleryActiveIndex: 0,
      todayIndex: new Date().getDay(),
      entered: false
    }
  },
  computed: {
    ...mapState('restaurant', {
      restaurants: 'restaurants',
      content: 'content'
    }),
    restaurant() {
      return (
        this.restaurants &&
        this.restaurants.find(restaurant => restaurant.slug === this.$route.params.restaurantSlug)
      )
    },
    relevantContent() {
      if (!this.restaurant) {
        return null
      }
      return this.content[this.restaurant.pos_id]
    },
    galleryImages() {
      return this.gallery ? this.gallery.images.map(image => ({ src: image.path, ...image })) : []
    },
    gallery() {
      return (
        this.relevantContent &&
        this.relevantContent.find(contentModule => contentModule.type === 'carousel')
      )
    },
    googleMapsLink() {
      const module =
        this.relevantContent &&
        this.relevantContent.find(contentModule => contentModule.type === 'restaurant-map')

      if (module) {
        return module.link
      } else {
        return null
      }
    }
  },
  watch: {
    restaurant() {
      this.$store.dispatch('restaurant/FETCH_CONTENT', this.restaurant.pos_id)
    }
  },
  created() {
    if (!this.relevantContent && this.restaurant) {
      this.$store.dispatch('restaurant/FETCH_CONTENT', this.restaurant.pos_id)
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.galleryActiveIndex = 0
    next()
  },
  methods: {
    afterEnter() {
      this.entered = true
    },
    spaceEverySecondCharacter(str) {
      return str
        .replace(/[^\dA-Z]/g, '')
        .replace(/(.{2})/g, '$1 ')
        .trim()
    },
    handleGalleryChange(index) {
      this.galleryActiveIndex = index
    }
  }
}
</script>

<style lang="scss">
@import '~@/halifax-ui/src/scss/framework';
@import '~@/scss/variables';

.restaurants {
  $module: '.restaurants';

  &__gallery-wrap {
    position: relative;
    background: $background-dark;

    &::after {
      content: '';
      padding-bottom: percentage(500/750);
      display: block;
    }
  }
  &__intro {
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: rgba($text-color, 0.5);
    pointer-events: none;
    text-shadow: 0 0 15px rgba($text-color, 0.75);

    a {
      font-size: 1.6rem;
      font-weight: 700;
      text-decoration: none;
      color: inherit;
      opacity: 0.75;

      &[href] {
        // text-decoration: underline;
        pointer-events: auto;
      }
    }
  }
  &__gallery {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .hui-gallery__dots {
      z-index: 1;
    }
  }
  &__gallery-slide {
    width: 25%;
  }
  &__content-module {
    &:not(:first-of-type) {
      margin-top: 40px;
    }
    &:first-of-type {
      margin-top: 30px;
    }
    &:not(:last-of-type) {
      margin-bottom: 40px;
    }
  }
  &__opening-hours {
    // background-color: $background-light-50;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    dl {
      overflow: hidden;
      width: 100%;
    }
    dt,
    dd {
      float: left;
      padding: 6px 0;
      width: 50%;
      white-space: nowrap;

      &:not(:nth-of-type(1)) {
        border-top: 1px dotted rgba($text-color, 0.2);
      }
    }
    dt {
      clear: left;
      text-align: left;
      // width: 50%;
    }
    dd {
      text-align: right;
      // width: 50%;
    }
  }
}
</style>
